/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Integration_Limits_BodyInputs */

const en_svc_integration_limits_body = /** @type {(inputs: Svc_Integration_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI that writes into your records needs the same care as any other user with write access.`)
};

const lv_svc_integration_limits_body = /** @type {(inputs: Svc_Integration_Limits_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI, kas raksta Jūsu ierakstos, prasa tādu pašu rūpību kā jebkurš lietotājs ar rakstīšanas tiesībām.`)
};

/**
* | output |
* | --- |
* | "AI that writes into your records needs the same care as any other user with write access." |
*
* @param {Svc_Integration_Limits_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_integration_limits_body = /** @type {((inputs?: Svc_Integration_Limits_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Integration_Limits_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_integration_limits_body(inputs)
	return en_svc_integration_limits_body(inputs)
});